import { Box, Text, theme } from "@xometry/xometry_loft";
import React, { useState } from "react";
import { UnitOfMeasurement } from "../../../schema/generated/schema";
import fileUtils from "../../../utils/fileUtils";
import FileUnitRadioGroup from "../../FileShare/FileUnitRadioGroup";
import Modal from "../Common/Modal";

type FileUnitModalProps = {
  modalOpen: boolean;
  closeModal: () => void;
  onSubmit: (fileUnits: Record<string, UnitOfMeasurement>) => void;
  files: File[];
};

const FileUnitModal: React.FC<FileUnitModalProps> = ({
  modalOpen,
  closeModal,
  onSubmit,
  files,
}) => {
  const [fileUnits, setFileUnits] = useState<Record<string, UnitOfMeasurement>>(
    files.reduce((memo, file) => {
      return { ...memo, [file.name]: UnitOfMeasurement.Mm };
    }, {})
  );

  const handleSubmit = () => {
    if (typeof onSubmit === "function") {
      onSubmit(fileUnits);
    }
  };

  const unitlessFiles = files.filter(file =>
    fileUtils.fileNeedUserInputForUnits(file.name)
  );

  if (!modalOpen || (files.length && !unitlessFiles.length)) {
    return null;
  }

  const plural = unitlessFiles.length > 1;

  return (
    <Modal
      isOpen={modalOpen}
      selector="#modal-mount"
      title={`CAD File Dimension${plural ? "s" : ""}`}
      description={
        "To ensure accuracy of quoting, what is the intended" +
        ` dimension type of the following file${plural ? "s" : ""}:`
      }
      submitActionText={`Add Dimension${plural ? "s" : ""}`}
      handleCloseButton={closeModal}
      handleCancel={closeModal}
      handleSubmit={handleSubmit}
    >
      {unitlessFiles.map(file => {
        return (
          <Box key={file.name} marginBottom={theme.space[4]}>
            <Text kind="body-title">{file.name}</Text>
            <FileUnitRadioGroup
              name={file.name}
              defaultValue={fileUnits[file.name]}
              onChange={unit => {
                setFileUnits(prevFileUnits => {
                  return { ...prevFileUnits, [file.name]: unit };
                });
              }}
              scale="medium"
              labels={{
                [UnitOfMeasurement.Mm]: "Millimeters",
                [UnitOfMeasurement.In]: "Inches",
              }}
            />
          </Box>
        );
      })}
    </Modal>
  );
};

export default FileUnitModal;
